import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgMaskan = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      fill='#E35732'
      fillRule='evenodd'
      clipPath='url(#maskan_svg__a)'
      clipRule='evenodd'
    >
      <path d='M3.403 3.538h17.194v16.925H3.403zM0 0v24h24V0z' />
      <path d='M18.962 14.978v-4.044l-7.198-2.657-7.199 2.657v4.044l7.199-2.658z' />
    </g>
    <defs>
      <clipPath id='maskan_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgMaskan)
export default ForwardRef
